import { MsalAuthenticationResult } from '@azure/msal-react';

export function MsalAuthErrorComponent({ error }: Readonly<MsalAuthenticationResult>) {
  return (
    <div style={{ padding: 24 }}>
      <h1>Authentication failed</h1>

      {error ? (
        <pre style={{ whiteSpace: 'pre-wrap' }}>
          {error.errorCode ? `${error.errorCode}\n` : ''}
          {error.errorMessage || error.message}
        </pre>
      ) : (
        <p>No error</p>
      )}

      <button onClick={() => globalThis.location.reload()}>Try again</button>
    </div>
  );
}
